import * as React from 'react';
import { HrefLangsTagsProps } from './types';

export default function HrefLangsTags({ hrefLangs, path }: HrefLangsTagsProps): JSX.Element {
  return (
    <>
      <link data-testid="HrefLangsTags__Canonical" rel="canonical" href={path} />
      {hrefLangs?.map(({ lang, href }) => (
        <link data-testid="HrefLangsTags__Alternate" key={lang} rel="alternate" href={href} hrefLang={lang} />
      ))}
    </>
  );
}
